jQuery(function($) {

	var h_top_header = 20;
    var header = $('#masthead');
    var l_window = parseInt($(window).width());


 


  //  /******* SLIDER ROW 1 *********/
  //  /****************************************/
  //   $('.gallery_js').slick({
  //    slidesToShow: 1,
  //    slidesToScroll: 1,
  //    // adaptiveHeight: true,
  //    arrows: true,
  //    fade: true,
  //    autoplay:true,
  //    autoplaySpeed: 4000,
  //    focusOnSelect: false,
  //    pauseOnFocus:false,
  //    dots:false
  // });




 $(window).scroll(function () {
      action_on_scroll();
  });

  function action_on_scroll(){

     if ($(window).scrollTop() > 0){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
         header.removeClass("Masthead--sticky");
        $("body").removeClass('header--sticky');
      }

   }


  // /* VAR */
   

    var bg_transition = document.getElementById('bg_transition');

      function getTransitionEndEventName() {
        var transitions = {
            "transition"      : "transitionend",
            "OTransition"     : "oTransitionEnd",
            "MozTransition"   : "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
         };
        let bodyStyle = document.body.style;
        for(let transition in transitions) {
            if(bodyStyle[transition] != undefined) {
                return transitions[transition];
            } 
        }
      }
      // using above code we can get Transition end event name
      let transitionEndEventName = getTransitionEndEventName();

      function removePopClass(){
        $('.ContainAllMenu-Aside').removeClass('pop');
      }

      var memory_bg_grey = false;
      var transition_arrow = '';
       $(".menu-toggle").click(function(e){
          if($(this).attr('aria-expanded') == 'true'){
            $('body').addClass('open_menu');
            if($('body').hasClass('bg_grey_scroll')) memory_bg_grey = true;
            $('body').removeClass('bg_grey_scroll');
            // if(l_window > 768){
            //   disappear_logo();
            // }
            $('.ContainAllMenu-Aside').addClass('pop');
            $('.ContainAllMenu-Aside').attr('aria-hidden', true);
            bg_transition.removeEventListener(transitionEndEventName,removePopClass);


             /******* Animation fleche *******/
            //MorphSVGPlugin.convertToPath("#carre_depart");
             transition_arrow = gsap.fromTo("#carre_depart", {morphSVG:"#carre_depart"},{duration: 0.4, morphSVG:"#arrow_final",ease:Power3.easeOut, delay:0.5});
                   
          }else{
             $('body').removeClass('open_menu');
             if(memory_bg_grey) $('body').addClass('bg_grey_scroll');
             $('.ContainAllMenu-Aside').attr('aria-hidden', false);
           //  if(scrolltop_memory > 100 && l_window > 768) disappear_logo();else{appear_logo();} // je sais pas gérer ca pour l'instant... disparition du logo en fonction du scrool...
             bg_transition.addEventListener(transitionEndEventName,removePopClass);
             transition_arrow.reverse();
          }
       });  



       /********************/
        /* Animation logo */
       /********************/

       // .logo_bottom
       MorphSVGPlugin.convertToPath("circle");
       //gsap.from(".logo_bottom",{duration:3, drawSVG:0,ease:Power3.easeOut, delay:0.5});

        anim_logo_g = gsap.fromTo(".depart_l", {scale:1,morphSVG:".depart_l"},{stroke:'#5EBB4F',scale:1,duration: 0.4, morphSVG:".final_l",ease:Back.easeOut.config(2), delay:1});
        anim_logo_d = gsap.fromTo(".depart_r", {scale:1,morphSVG:".depart_r"},{stroke:'#5EBB4F',scale:1,duration: 0.4, morphSVG:".final_r",ease:Back.easeOut.config(2), delay:1.2});
             

       


         //  /******* ANIMATION SCROLL BLOCK *********/
        //  /****************************************/


    ///** VOIR ScrollTrigger.matchMedia*****///
    //   ScrollTrigger.matchMedia({ // exemple here https://codepen.io/DeCodeUI/pen/xxdLVaY
    // "(min-width: 992px)": function() {

    if(l_window > 1099){

     const tabsItemScroll = gsap.utils.toArray('.ScrollItem');
     var cache_container = document.querySelector('.hScrollItem--bgbottom');
     var hTotalScroll = $('.hScrollItem-inner').height();
   
        ScrollTrigger.create({
             trigger: $('.hScrollItem-inner'),
            // scroller: document.body, // neccessary setting for smooth-scrollbar on body
             pinType: 'transform', // neccessary setting for smooth-scrollbar on body
             start: "top top",
             end: "bottom top",
             pin: cache_container,
             scrub: 1
        });

      tabsItemScroll.forEach((itemScroll,i) => {

        var h_this_one = hTotalScroll - $(itemScroll).innerHeight()*(i+1)+ 600; // 600 PODOM
        
        var img_scrollItem = itemScroll.querySelector('.ScrollItem-Img');
        var LeftCol = itemScroll.querySelector('.ScrollItem-L');
       
        //  
        ScrollTrigger.create({
                trigger:itemScroll,
                // scroller: document.body, // neccessary setting for smooth-scrollbar on body
                 pinType: 'transform', // neccessary setting for smooth-scrollbar on body
              //  markers: true,
                pin: LeftCol,
                start: "top top",
                //end: "+=3000", // 800 ?
                end: "+=40%",
                scrub: 1 // 2?
        });
       
          ScrollTrigger.create({
                trigger:itemScroll,
                // scroller: document.body, // neccessary setting for smooth-scrollbar on body
                 pinType: 'transform', // neccessary setting for smooth-scrollbar on body
              //  markers: true,
                pin: img_scrollItem,
                start: "top top",
                //end: "+=3000", // 800 ?
                end: "+="+h_this_one,
                scrub: 2 // 2?
            });


          // MORPHING TRAIT SOUS TITRE ?

           // ScrollTrigger.create({
           //      trigger: itemScroll,
           //      start: "top bottom",
           //      end: "center top",
           //      onUpdate:function(self){
           //          // if(self.progress > 0.10){
           //          //    itemScroll.style.zIndex = 10;
           //          // }else{
           //          //     itemScroll.style.zIndex = 0;
           //          // }
           //      },
           //      onEnter: function () {
           //          primary_container.style.background = color_hexa_bg;
           //          cache_container.style.background = color_hexa_bg;
           //          //itemScroll.style.zIndex = 10;   
           //      },
           //      onEnterBack: function () {
           //          primary_container.style.background = color_hexa_bg;
           //          cache_container.style.background = color_hexa_bg;
           //      },
           //      onLeave: function () {
           //         // document.querySelector("CaseStudy").style.background = color_hexa_bg;
           //      },
           //      onLeaveBack: function () {
           //          //document.querySelector("CaseStudy").classList.remove("bg_grey_scroll");
           //      },

           //  });

      });

    
         if ( $( ".ScrollItem-L" ).length ) {  
          const box_left_item_scroll = gsap.utils.toArray('.ScrollItem-L');

          box_left_item_scroll.forEach(box => {

            var trait_title = box.querySelector('.ScrollItem-Title .cache_svg');
               
              gsap.from(trait_title, {
              width: '100%',
              ease: "none",
              scrollTrigger: {
                trigger:box,
                // start: "top bottom", // the default values
                 end: "bottom center",
                scrub: true
              }, 
            });

          //     var header_title = box.querySelector('.ScrollItem-Title');
          //      console.log(header_title);
          //     gsap.from(header_title, {
          //     opacity: 150,
          //     ease: "none",
          //     scrollTrigger: {
          //       trigger:box,
          //       // start: "top bottom", // the default values
          //        end: "bottom center",
          //       scrub: true
          //     }, 
          //   });

            //   var content_middle = box.querySelector('.ScrollItem-Desc');
            //   gsap.from(content_middle, {
            //   y: 130,
            //   ease: "none",
            //   scrollTrigger: {
            //     trigger:box,
            //     // start: "top bottom", // the default values
            //      end: "bottom center",
            //     scrub: true
            //   }, 
            // });

            //   var content_link = box.querySelector('.ScrollItem-Link');
            //   gsap.from(content_link, {
            //   x: 120,
            //   ease: "none",
            //   scrollTrigger: {
            //     trigger:box,
            //     // start: "top bottom", // the default values
            //      end: "bottom center",
            //     scrub: 1
            //   }, 
            // });

              

          });
         }

        } // fin si > 1100




        /*******************************************************/
        /************ ANIMATION ENTREPRISE *******/  
        /*******************************************************/

        function change_class(labelstring){
          $('.navContainer button').removeClass('active');
          $('.navContainer button[data-label="'+labelstring+'"]').addClass('active');
        }

        var tl = gsap.timeline({repeat: -1, repeatDelay: 0});

        tl.addLabel("start");
        //tl.call(change_class,['step-1']);
        tl.fromTo(".step-1-A", {scaleY:-0.3,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Back.easeOut},'');
        tl.fromTo(".step-1-B", {scaleY:-0.3,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Back.easeOut},'<+0.1');
        tl.fromTo(".step-1-C", {scaleY:-0.3,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Back.easeOut},'<+0.1');
        tl.fromTo(".step-1-D", {scaleY:-0.3,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Back.easeOut},'<+0.1');
        tl.fromTo(".step-1-E", {scaleY:-0.3,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Back.easeOut},'<+0.1');

        


        tl.addLabel("step-2", '+=2');
        //tl.call(change_class,['step-1']);
        tl.to(".step-2-A", {y: '100%',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, 'step-2');
        tl.fromTo(".step-2-B", {scaleY:-0.3,y:'-100%',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');
        tl.to(".step-2-C", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, 'step-2');
        tl.fromTo(".step-2-D", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');
        
        tl.addLabel("step-3", '+=2');
        //tl.call(change_class,['step-2']);
        tl.to(".step-3-A", {scaleX: 0,duration: 0.5,ease: Back.easeIn.config(1.4)}, 'step-3');
        tl.to(".step-3-B", {scaleX: 0,duration: 0.5,ease: Back.easeIn.config(1.4)}, '<+0.1');
        tl.to(".step-3-C", {scaleX: 0,duration: 0.5,ease: Back.easeIn.config(1.7)}, '<+0.1');
        tl.fromTo(".step-3-D", {scaleX:-0,filter: "blur(2px)"},{scaleX: 1,filter: "blur(0px)",duration: 0.5,ease:Power3.easeOut},'<+0.5');
        tl.to(".step-3-E", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, '<');
        tl.fromTo(".step-3-F", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');

        tl.addLabel("step-4", '+=2');
        //tl.call(change_class,['step-3']);
        tl.to(".step-4-A", {x: '-100%',duration: 0.4,ease: Back.easeInOut.config(1.4)}, 'step-4');
        tl.to(".step-4-B", {x: '200%',filter: "blur(2px)",duration: 1,ease: Power3.easeOut}, '<+0.1');
        tl.fromTo(".step-4-C", {x:'250%',filter: "blur(2px)"},{x:0,filter: "blur(0px)",duration: 0.5,ease:Power3.easeOut},'<+0.1');
        tl.fromTo(".step-4-D", {x:'250%',filter: "blur(2px)"},{x:0,filter: "blur(0px)",duration: 0.5,ease:Power3.easeOut},'<+0.1');
        tl.to(".step-4-E", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, '<');
        tl.fromTo(".step-4-F", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');


        tl.addLabel("step-5", '+=2');
        //tl.call(change_class,['step-4']);
        tl.to(".step-5-A", {scaleX: '0',duration: 0.5,ease: Back.easeIn.config(1.4)}, 'step-5');
        tl.fromTo(".step-5-B", {scaleX:'0'},{scaleX:1,duration: 0.5,ease:Power3.easeOut},'<+0.5');
        tl.to(".step-5-C", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, '<');
        tl.fromTo(".step-5-D", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');
        

        tl.addLabel("step-6", '+=2');
        //tl.call(change_class,['step-5']);
        tl.fromTo(".step-6-A", {x:'100%',opacity:0},{opacity:1,x:0,duration: 0.5,ease:Power3.easeOut},'step-6');
        tl.to(".step-6-B", {x: '100%',rotation:360,duration: 0.6,ease: Back.easeOut.config(1.7)}, '<+0.1');
        tl.to(".step-6-C", {x: '-100%',rotation:-360,duration: 0.6,ease: Back.easeOut.config(1.7)}, '<');
        tl.to(".step-6-D", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, '<');
        tl.fromTo(".step-6-E", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');

        tl.addLabel("step-7", '+=2');
        //tl.call(change_class,['step-6']);
        tl.to(".step-7-A", {rotationX:360,scale:1.1,duration: 0.5,ease:Power2.easeOut},'step-7');
        tl.to(".step-7-B", {rotationX:360,scale:1.1,duration: 0.5,ease:Power2.easeOut},'<+0.05');
        tl.to(".step-7-C", {rotationX:360,scale:1.1,duration: 0.5,ease:Power2.easeOut},'<+0.05');
        tl.to(".step-7-D", {rotationX:90,duration: 0.3,ease:Power2.easeOut},'<');
        tl.to(".step-7-E", {rotationX:360,y:0,scale:1.1,filter: "blur(0px)",duration: 0.5,ease:Power2.easeOut},'<+0.05');
        tl.to(".step-7-F", {y: '90px',filter: "blur(2px)",duration: 0.5,ease: Back.easeIn.config(1.7)}, '<');
        tl.fromTo(".step-7-G", {scaleY:0,y:'-90px',filter: "blur(2px)"},{y: 0,scaleY:1,filter: "blur(0px)",duration: 0.5,ease:Bounce.easeOut},'<+0.3');
        tl.to(".step-7-G", {scale: 1.2,duration: 3,ease: Power2.easeOut}, '<+0.4');

       
        tl.addLabel("step-8", '+=2');
        //tl.call(change_class,['step-7']);
        tl.to(".step-7-A", {y:'10px',scale:1.1,opacity:0,duration: 3,ease:Power2.easeOut},'step-8');
        tl.to(".step-7-B", {y:'10px',scale:1.1,opacity:0,duration: 3,ease:Power2.easeOut},'step-8');
        tl.to(".step-7-C", {y:'10px',scale:1.1,opacity:0,duration: 3,ease:Power2.easeOut},'step-8');
        tl.to(".step-7-E", {y:'10px',scale:1.1,opacity:0,duration: 3,ease:Power2.easeOut},'step-8');
        tl.to(".step-7-G", {y:'10px',opacity:0,duration: 3,ease:Power2.easeOut},'<+0.2');


        
      // $( ".js-step-animation-button" ).click(function() {
      //   var label =  $(this).data('label');
      //   tl.play(label);
      // });







    /******************************************/
    /******* SLIDER HOTSPOT POUR MOBILE - PAGE ENTREPRISE *****/
    /******************************************/
       if ( $( ".HotSpot-Button" ).length ) {  

      $('.js-slider-interactivite').slick({
          arrows: true,
          autoplay:true,
          autoplaySpeed: 4000,
          slidesToScroll: 1,
          slidesToShow: 1,
          dots:false,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          mobileFirst: true,
          responsive: [
          {
                  breakpoint: 768,
                  settings: 'unslick'
          }
        ]
    });
     

      tippy('.HotSpot-Button', {
        content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      interactive: true,
      maxWidth: 500,
      theme: 'tribu',
      offset: [15, 15],
      animation: 'rotate',
      moveTransition: 'transform 0.2s ease-out',
      appendTo: () => document.body,
      onTrigger(instance, event) {
        if(l_window < 768){
          let id_instance = instance.id;
          $('.js-slider-interactivite').slick('slickGoTo', id_instance - 1);
          
          offsetTop = $('.InteractiveValeur').offset().top-header.height();
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);

        }
        //console.log(instance.);
      //console.log(instance.getAttribute('data-template'));
      }
    });

    } // si page entreprise


    // $('.js-slider-interactivite').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //   console.log(nextSlide);
    //   const instance_new = document.querySelectorAll('.slide-'+nextSlide+' .HotSpot-Button')[0];
    //   instance_new._tippy.show();
    // });





    /******************************************/
    /******* SLIDER PARTENAIRE DESSOUS HOTSPOT - PAGE ENTREPRISE *****/
    /******************************************/

    
    $('.js-slider-client').slick({
          arrows: true,
          autoplay:true,
          autoplaySpeed: 2000,
          slidesToScroll: 1,
          slidesToShow: 6,
          dots:false,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1420,
              settings: {
                 slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
             {
              breakpoint: 1024,
              settings: {
                 slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                 slidesToShow: 2,
                slidesToScroll: 2,
                dots:true,
                arrows: false
              }
            }
          ]
    });

      


      /******************************************/
    /*******  PAGE APPROCHE *****/
    /******************************************/

      /******************************************/
    /*******  APPARITION DU SOULIGNE DEPUIS WYSIWYG *****/
     $( "span.souligne_svg" ).each(function( index ) {
       $(this).append('<svg xmlns="http://www.w3.org/2000/svg" width="416.469" height="16.701" viewBox="0 0 416.469 16.701"><path data-name="Tracé 156" d="M0 16.701c17.172-2.881 34.432-5.148 51.721-7.217 4.323-.512 8.651-.977 12.978-1.449s8.663-.854 13-1.284l13-1.221q6.506-.563 13.018-1.05Q155.81.445 208.117.038q52.263-.362 104.457 2.846c4.348.223 8.688.593 13.032.89 4.342.324 8.686.6 13.023.979 8.675.758 17.351 1.459 26.009 2.383l12.984 1.376c4.324.5 8.649.982 12.967 1.529 8.644 1.011 17.263 2.252 25.876 3.492-34.789-1.374-69.487-2.876-104.2-3.683q-52.056-1.257-104.088-.947-52.037.4-104.061 2.514l-13.01.509-12.996.616q-13.012.562-26.023 1.261c-17.355.859-34.7 1.967-52.086 2.9" fill="#f4db31"/></svg>');
       // $(this).append('<svg viewBox="0 0 145 19" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><path d="M6 14.92C174.67-6.395 182.713-9.572 31.251 17" stroke="#C58F70" transform="rotate(7 72.5 7.5)" stroke-dasharray="244 246" stroke-dashoffset="245"/></g></svg>');
    });


       /******************************************/
    /*******  PAGE APPROCHE - BIG ANIMATION *****/
    /******************************************/

     /* Tous les dechets */
       const tab_dechets = gsap.utils.toArray('.anim_dechet1');
      tab_dechets.forEach((dechet) => {
         gsap.fromTo(dechet, {y:-70, scale:1,opacity:1},{
          scale:0,
          opacity:0,
          y:100,
          scrollTrigger: {  
            trigger:dechet ,
            start: "center+=200 center+=200",
            //end: "bottom-=75 top",
            scrub:true
          }
        });
      });


      // boite de conserve
      gsap.fromTo('.anim_dechet2', {y:-70, scale:1,opacity:1},{
          scale:1,
          y:750,
          opacity:0,
          scrollTrigger: {  
            trigger:'.anim_dechet2' ,
            start: "center+=200 center+=200",
            end: "+=1200",
            //scrub:true,
           // toggleActions : 'restart pause reverse pause',
            scrub:true
          }
        });
      
       var megto_plus;
      if(l_window > 768){
           megto_plus = 400;
      }else{
          megto_plus = 500;
      }

      // MEGOT
      gsap.fromTo('.anim_dechet3', {y:-70, scale:1,opacity:1},{
          scale:1,
          y:megto_plus,
          scrollTrigger: {  
            trigger:'.anim_dechet2' ,
            start: "center+=200 center+=200",
            end: "+=400",
            //scrub:true,
           // toggleActions : 'restart pause reverse pause',
            scrub:true
          }
        });
   

      // gsap.fromTo('.AnimDechet', {y:0},{
      //     y:100,
      //     scrollTrigger: {  
      //       trigger:'.AnimDechet' ,
      //       start: "top top",
      //       //end: "top top",
      //       scrub:true
      //     }
      //   });

    
       let tl_camion = gsap.timeline({
         scrollTrigger: {
          trigger: ".ContentAnimEnd",
         // pin: true,   // pin the trigger element while active
          start: "bottom bottom", // when the top of the trigger hits the top of the viewport
          end: "+=400", // end after scrolling 500px beyond the start
          scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
          // snap: {
          //   snapTo: "labels", // snap to the closest label in the timeline
          //   duration: {min: 0.2, max: 3}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
          //   delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
          //   ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
          // }
        }});

       var avancement_camion = '150%';
       if(l_window > 1450){
         avancement_camion = '150%';
       }else{
         avancement_camion = '100%';
       }

        tl_camion.addLabel("start");
        //tl_camion.call(change_class,['step-1']);
        tl_camion.fromTo("#toit_voiture", {rotation:0},{transformOrigin:"145px 208px",rotation: 120,duration: 3,ease:Power1.easeOut},'');
        tl_camion.fromTo(".voiture", {x:-50},{x:avancement_camion,duration: 3,ease:Power1.easeIn},'<1');
        
    

    /******************************************/
    /******* SLIDER TEMOIGNAGE - PAGE SOLUTION *****/
    /******************************************/

    
    $('.js-testimony').slick({
          arrows: false,
          autoplay:true,
          autoplaySpeed: 4000,
          slidesToScroll: 1,
          slidesToShow: 1,
          dots:true,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
    }); 



  /******************************************/
    /******* CONTACT FORM 7 *****/
  /******************************************/

  $( ".wpcf7-form label.to_move_l" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

  /******************************************/
    /******* TIMELINE PAGE CONTACT *****/
  /******************************************/


  var tl_anim_contact = gsap.timeline({repeat: -1, repeatDelay: 0});

 

  tl_anim_contact.addLabel("start");
  //tl_anim_contact.call(change_class,['step-1']);
  tl_anim_contact.to("#feuille", {morphSVG:"M163.9,377c-17.8-11.9-9.8-39.4-6.3-94.2  c1.6-24.7,8.4-44.8,14.6-58.8c0,0,15.2,58,45.4,75.3c0,0-13.6,56.1,40.5,142.7c-10.8,7.8,0,0,0,0c-23.1-16-51.5-36.2-69.4-48.1  L163.9,377z", duration: 0.6,ease:Power0.easeNone});
  tl_anim_contact.to("#feuille", {morphSVG:"M188.7 393.9c-17.8-11.9-34.6-56.3-31.1-111.1 1.6-24.7 8.4-44.8 14.6-58.8 0 0 25.5 69.1 55.7 86.4 0 0 41 123.8 30.2 131.6-10.8 7.8 0 0 0 0-23.1-16-51.5-36.2-69.4-48.1z", duration: 0.6,ease:Power0.easeNone});
 









});


